import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
export const TopImageZoomSliderModalButtonBase = (props) => {
    const { className = '', dataAttributes, disabled, icon: Icon, onClick, } = props;
    return (_jsx("button", Object.assign({ className: clsx('inline-flex items-center justify-center', 'w-[70px] h-[70px] !rounded-none', '!bg-blue-gray-200 md:opacity-60', disabled && 'cursor-not-allowed', className), onClick: onClick, type: 'button' }, dataAttributes, { children: _jsx(Icon, { color: 'white', size: 'sm' }) })));
};
